module.exports = __webpack_public_path__ + "static/img/bg_5.42255f11.jpg";